"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var App = /*#__PURE__*/function (_Vue) {
  function App() {
    (0, _classCallCheck2.default)(this, App);
    return (0, _callSuper2.default)(this, App, arguments);
  }
  (0, _inherits2.default)(App, _Vue);
  return (0, _createClass2.default)(App);
}(_vuePropertyDecorator.Vue);
App = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], App);
var _default = exports.default = App;